// GENERATED by scripts/gen-version.js — do not edit; bump "version" in package.json instead.
export const APP_VERSION = '8.0.43'
